jQuery(document).ready(function($) {
    const base = "gc-account";

	$('.gp-login__form').submit(function(e) {
		e.preventDefault();
		$(`.${base}__submit`).prop('disabled', true);

		const formData = $(this).serialize();
		const url = $(this).attr('action');
		$.ajax({
			url : url,
			type: 'POST',
			data : formData
		}).done(function(responseRaw) {
			$(`.${base}__submit`).prop('disabled', false);
			let response = JSON.parse(responseRaw);
			
			if(response.success) {
				window.location.replace('/');
			} else {
				$(`.${base}__message`).html(response.message).show();
			}
		});
	});

	$('.gp-login__lost-password').on('submit', function(e) {
		e.preventDefault();
		$(`.gp-login__modal-submit`).prop('disabled', true);

		fetch('/wp-json/growl/customer/resetPassword', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify({
				email: $('.gp-login__lost-password input[type=email]').val()
			}),
		})
		.then((response) => response.json())
		.then(response => {
			$(`.gp-login__modal-submit`).prop('disabled', false);

			if (response.success) {
				$('.gp-login__modal-success--hidden').removeClass('gp-login__modal-success--hidden')
				$('.gp-login__lost-password').addClass('gp-login__lost-password--hidden')
			} else {
				showToast('Error');
			}
		})
	});
});